import React from 'react'
import SvgIcon from './SvgIcon'

export default SvgIcon(
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.87 9.87"><title>SiteIcons</title><path d="M8.45,9.62A.83.83,0,1,0,9.62,8.45L6.1,4.93,9.62,1.41A.83.83,0,1,0,8.45.24L4.93,3.76,1.41.24A.83.83,0,0,0,.24,1.41L3.76,4.93.24,8.45A.83.83,0,1,0,1.41,9.62L4.93,6.1Z"/></svg>
)